var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.535,
    height: 30.564,
    viewBox: "0 0 31.535 30.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3552",
    "data-name": "Group 3552",
    transform: "translate(22397.75 1759.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "favorite_1_",
    "data-name": "favorite (1)",
    d: "M22.279,10.346a8.715,8.715,0,0,0-6.762,3.241,8.714,8.714,0,0,0-6.762-3.241A8.822,8.822,0,0,0,0,19.213c0,3.829,2.254,8.257,6.7,13.162a64.807,64.807,0,0,0,8.2,7.5l.615.468.615-.468a64.8,64.8,0,0,0,8.2-7.5c4.446-4.905,6.7-9.334,6.7-13.162A8.822,8.822,0,0,0,22.279,10.346Zm.548,20.628a62.514,62.514,0,0,1-7.31,6.771,62.524,62.524,0,0,1-7.31-6.771C4.177,26.527,2.046,22.46,2.046,19.213a6.692,6.692,0,0,1,12.576-3.288l.895,1.635.895-1.635a6.692,6.692,0,0,1,12.576,3.288C28.988,22.46,26.858,26.527,22.827,30.974Z",
    transform: "translate(-22397.5 -1769.846)",
    fill: "#dc3a1a",
    stroke: "#dc3a1a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9058",
    "data-name": "Path 9058",
    d: "M-22381.25-1732.062l9-8.312,2.875-4.812,1.063-2.562.688-4.812-2.437-3.562-5.312-2.312-5.375,2.625-1.375,2.438-2.437-3.687-5.312-1.062-3.625,2-2.312,2.75v3.438l1.188,5.313,4.438,6.375,8.063,6.813Z",
    fill: "#dc3a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteOrange);
export default __webpack_public_path__ + "static/media/favourite_orange.fba81806a48a2ea3e1d9f941355357f8.svg";
export { ForwardRef as ReactComponent };